export default __webpack_public_path__ + "images/8aefd6e7bbdf8a5798ce5388b6d44a3c.png";